{
  "errors": {
    "yourRoleDoesNotAllowThisAction": "Your role does not allow you to {action}",
    "yourRoleDoesNotAllowYouToPerformThisAction": "Your role does not allow you to perform this action",
    "mustHaveAtLeast8Characters": "Must have at least 8 characters",
    "mustContainUpperCaseAndLowerCase": "Must contain upper-case and lower-case",
    "mustContainAtLeastOneLetter": "Must contain at least one letter",
    "mustContainAtLeastOneSpecialCharacter": "Must contain at least one special character",
    "mustContainAtLeastOneNumber": "Must contain at least one number"
  },
  "descriptions": {
    "allPermissionsAndFullControlOverAllAccounts": "All permissions and full control over all accounts.",
    "godRoleWithLessControl": "GOD role with less control.",
    "allPermissionsAndFullControlOverTheOrganizationAccount": "All permissions and full control over the Organization account.",
    "createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "Create/edit/delete Appointments, Warehouses, Load Types, Docks, and Users (except Owners).",
    "createEditCancelAppointments": "Create/edit/cancel Appointments.",
    "editAppointmentStatusTagsAndSubscribers": "Edit Appointment Status, tags, and subscribers.",
    "viewOnlyNoCreateOrEditActionsAllowed": "View only. No create or edit actions allowed.",
    "carrierAdministrator": "Carrier administrator.",
    "carrierUser": "Carrier user",
    "baseUserAccount": "Base user account.",
    "warehouseDriverHasLimitedAccessToTheApplication": "Warehouse driver, has limited access to the application."
  }
}
